export const selectbutton = {
  colorScheme: {
    light: {
      background: '{surface.400}',
      borderColor: '{primary.400}',
      color: '{paginator.color}',
      navButton: {
        color: 'black',
        selectedColor: 'black',
      },
    },
    dark: {
      background: '#3C434F',
      color: '#aeb5b7',
      currentPageReportColor: '#aeb5b7',
      navButton: {
        color: '#ffffff',
        selectedColor: '#ffffff',
      },
    },
  },
};
